import type { SVGProps } from 'react';
export const Youtube = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fill="#FF0000"
      d="M16.71 7.4a1.7 1.7 0 0 0-1.23-1.12C14.38 6 10 6 10 6s-4.38 0-5.48.26c-.59.15-1.07.6-1.23 1.15C3 8.4 3 10.5 3 10.5s0 2.1.29 3.1c.16.54.63.98 1.23 1.12C5.62 15 10 15 10 15s4.38 0 5.48-.26c.6-.15 1.07-.59 1.23-1.14.29-1 .29-3.09.29-3.09s.01-2.1-.29-3.1"
    />
    <path fill="white" d="m8.6 12.43 3.65-1.93L8.6 8.57z" />
  </svg>
);
